/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Cut_PlanInputs */

const en_portal_goal_cut_plan = /** @type {(inputs: Portal_Goal_Cut_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 strength sessions and 2 walks a week`)
};

const pl_portal_goal_cut_plan = /** @type {(inputs: Portal_Goal_Cut_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 treningi siłowe i 2 spacery w tygodniu`)
};

/**
* | output |
* | --- |
* | "3 strength sessions and 2 walks a week" |
*
* @param {Portal_Goal_Cut_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_cut_plan = /** @type {((inputs?: Portal_Goal_Cut_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Cut_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_cut_plan(inputs)
	return en_portal_goal_cut_plan(inputs)
});